import React, { createContext, useContext } from 'react'
import { initialAuthState } from './auth-state'

async function stub() {
  throw new Error('AuthProvider not initialized')
}

export const initialContext = {
  ...initialAuthState,
  isAuthenticated: false,
  login: stub,
  logout: stub,
  endSession: stub,
  impersonationLogin: stub,
  clearError: stub,
}

const AuthContext = createContext(initialContext)

export function useAuth() {
  return useContext(AuthContext)
}

/**
 * HOC for class components that need auth context.
 * Injects `auth` prop with the full useAuth() value.
 */
export function withAuth(Component) {
  const WithAuth = (props) => {
    const auth = useAuth()
    return <Component {...props} auth={auth} />
  }
  WithAuth.displayName = `withAuth(${Component.displayName || Component.name || 'Component'})`
  return WithAuth
}

export default AuthContext
